
import { useEffect } from "react";
import { useNavigate, Outlet, RouteProps, useSearchParams } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const AdminRoute = ({ ...props }: RouteProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        // Check if user is in invitation flow - if so, redirect to auth page
        const isInvitationFlow = searchParams.get('invited') === 'true';
        if (isInvitationFlow) {
          console.log('AdminRoute: User in invitation flow, redirecting to auth');
          navigate('/auth?invited=true');
          return;
        }

        // Check for active session first
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) {
          console.log('AdminRoute: No active session, redirecting to auth');
          navigate('/auth');
          return;
        }

        // Check if we have organization member ID
        const memberId = sessionStorage.getItem('organization_member_id');
        if (!memberId) {
          console.log('AdminRoute: No member ID found, redirecting to auth for context establishment');
          navigate('/auth');
          return;
        }

        // Check if this member has admin privileges
        const { data: member, error: memberError } = await supabase
          .from('organization_members')
          .select('role')
          .eq('id', memberId)
          .single();

        if (memberError) throw memberError;
        
        if (!member || member.role !== 'ADMIN') {
          throw new Error("Insufficient privileges - admin access required");
        }

        console.log('AdminRoute: Admin access verified for member:', memberId);
      } catch (error) {
        console.error('AdminRoute: Access check failed:', error);
        toast.error('Access denied. Admin privileges required.');
        navigate('/manager/dashboard');
      }
    };

    checkAdminAccess();
  }, [navigate, searchParams]);

  return <Outlet />;
};

export default AdminRoute;
